<template>
    <v-row>
        <template v-for="(item, index) in items">
            <v-col cols="12" lg="4" md="4" sm="12" class="mt-3" :key="index">
                <component
                    :is="item.component"
                    v-bind="getItemProps(item)"
                    :headingColor="$_.get(item, 'headingColor', 'primary')"
                    class="mb-6"
                    :id="item.id"
                    :title="item.title"
                    :icon="item.icon"
                    :height="$_.get(item, 'height', '')"
                    :maxHeight="item.maxHeight"
                ></component>
            </v-col>
        </template>
    </v-row>
</template>

<script>
export default {
    name: "program-process-blocks",
    components: {
        StudentProgram: () => import("./StudentProgram.vue"),
        StudentInstructor: () => import("./StudentInstructor.vue"),
        StudentInfo: () => import("./StudentInfo.vue"),
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        currentStudent: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getItemProps({ id, title, icon, params }) {
            let props = {};
            for (const key in params) {
                props[key] =
                    params[key] === "currentStudent"
                        ? this.currentStudent
                        : this.$_.get(this.currentStudent, params[key]);
            }
            return {
                ...props,
                id,
                title,
                icon,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
</style>